import { isNotEmptyArray } from '@rumblefish/ui/Rumblefish23Theme';
import type { FC } from 'react';
import type { JobPostListProps } from './JobPost.types';
import {
  StyledTitle,
  JobPostListContainer,
  JobPostListColumn,
  StyledList,
  StyledListItem,
} from './styles';

export const JobPostList: FC<JobPostListProps> = ({ title, items }) => {
  if (!isNotEmptyArray(items)) {
    return null;
  }
  return (
    <JobPostListContainer>
      {title && (
        <JobPostListColumn left>
          <StyledTitle variant="display_xxs">{title}</StyledTitle>
        </JobPostListColumn>
      )}
      <JobPostListColumn fullWidth={!title}>
        <StyledList>
          {items.map((item, index) => (
            <StyledListItem key={index}>{item}</StyledListItem>
          ))}
        </StyledList>
      </JobPostListColumn>
    </JobPostListContainer>
  );
};
